import type LandingPricing from "@interfaces/LandingPricing";
import axios from "@utilities/axios";
import { create } from "zustand";

const STALE_AFTER_MS = 5 * 60 * 1000; // 5 minutes
const AFFILIATE = process.env.GATSBY_AFFILIATE_CODE ?? "";

export interface SimCardState {
  pricingData: LandingPricing | null;
  lastFetchedAt: number | null;

  setPricingData: (data: LandingPricing) => void;
  isStale: () => boolean;
  clear: () => void;
}

export const useSimCardStore = create<SimCardState>((set, get) => ({
  pricingData: null,
  lastFetchedAt: null,

  setPricingData: (data: LandingPricing) => {
    set({
      pricingData: data,
      lastFetchedAt: Date.now(),
    });
  },

  isStale: (): boolean => {
    const state = get();
    if (state.pricingData === null || state.lastFetchedAt === null) return true;
    return Date.now() - state.lastFetchedAt > STALE_AFTER_MS;
  },

  clear: () => {
    set({
      pricingData: null,
      lastFetchedAt: null,
    });
  },
}));

export const useSimCardState = (): SimCardState => {
  return useSimCardStore(state => {
    return state;
  });
};

export const prefetchSimCardPricing = (): void => {
  const store = useSimCardStore.getState();
  if (!store.isStale()) return;

  const formData = new FormData();
  formData.append("a", AFFILIATE.toUpperCase());
  formData.append("lang", "en-US");
  formData.append("one_time_products", "0");

  axios
    .post("/sim_card_landing_pricing/", formData)
    .then(response => {
      const data = response.data as LandingPricing;
      if (
        data?.countries != null &&
        data?.products != null &&
        Array.isArray(data.products)
      ) {
        useSimCardStore.getState().setPricingData(data);
      }
    })
    .catch(() => {
      // Silent fail — prefetch is best-effort
    });
};
